export default "__VITE_ASSET__Bftb$6fV__"